import { Component, OnInit, ViewChild } from '@angular/core';
import { PageConfig } from '../models/display/pageConfig';
import { PublicService } from '../api/public.service';
import { PageConfigService } from '../page-config.service';
import { AutorizationService } from '../api/autorization.service';
import { Station } from '../models/api_models/station';
import { LeafletMapComponent } from '../leaflet-map/leaflet-map.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-basic-autopartage',
  templateUrl: './basic-autopartage.component.html',
  styleUrls: ['./basic-autopartage.component.scss']
})
export class BasicAutopartageComponent implements OnInit {

  @ViewChild('leafletMap') leafletMapChild: LeafletMapComponent;

  private _currentGps: [number, number] = [.6311634, 3.0599573];
  get currentGps() {
    return this._currentGps;
  }
  set currentGps(currentGps) {
    this._currentGps = currentGps;
  }

  private _mapStationSelected: Station;
  get mapStationSelected(): Station {
    return this._mapStationSelected;
  }
  set mapStationSelected(mapStationSelected) {
    this._mapStationSelected = mapStationSelected;
  }



  // Stations autopartages envoyées sur le block leaflet et la selection des station du formulaire 
  private _stationList: Station[] = [];
  get stationList() {
    return this._stationList;
  }
  set stationList(stationList) {
    this._stationList = stationList;
  }

  private _stationSelected: Station = null;
  get stationSelected() {
    return this._stationSelected;
  }
  set stationSelected(stationSelected) {
    this._stationSelected = stationSelected;
  }


  stationChangedHandler(stationFocus: Station) {
    // console.log(stationFocus);
    this._currentGps = [stationFocus.latitude, stationFocus.longitude];
    this._mapStationSelected = stationFocus;
  }
  pageConfig: PageConfig = null;
  constructor(public route: ActivatedRoute , private publicApiService: PublicService, private pageConfigService: PageConfigService, private autorizationService: AutorizationService)
   { this.getUrl()
   }

  isMontDesAvaloirs = false;

  ApiInit() {

    if(location.pathname === "/velo"){
      var service = 10
    }else{
      var service = 1
    }

    this.publicApiService.getStationList(service).subscribe(
      reponse => {
        this._stationList = reponse;
        if (this._stationList.length > 0) {
          this._stationSelected = this._stationList[0];
        }
        // console.log(this.stationList);

      }
    );
  }

  public isLoad = false;
  private getService() {
    this.pageConfig = null;
    this.autorizationService.login(null).subscribe(
      reponse => {
        // console.log("login");

        this.pageConfigService.getConfig(this.pageConfigService.defaultConfig).subscribe(
          reponse => {
            //            this.pageConfig = <PageContent>reponse;
            // console.log("this.pageConfig");
            this.pageConfig = < PageConfig > reponse;
            // console.log(this.pageConfig.servicesList);

            this.isLoad = true;
          },
          error => {
            this.pageConfigService.getConfig(this.pageConfigService.defaultConfig).subscribe(
              reponse => {
                this.pageConfig = < PageConfig > reponse;
              }
            )
          }
        )
      }
    )
  }

  fragment : String;

  ngOnInit() {
    this.stationList = [];
    this.ApiInit();
    this.getService();
    this.route.fragment.subscribe(fragment => { 
         this.fragment = fragment; 
         //  console.log("auto off :",fragment);
         this.scrollHtag()});

  }

  scrollHtag() {
        if(this.fragment) {
          // document.querySelector('#' + this.fragment).scrollIntoView(false);
          window.location.href = "#comment-ca-marche"
        } 
  }


  // get url 
  getUrl(){
    let host = location.host
    if(host ===  `mont-des-avaloirs.clem.mobi`){
      this.isMontDesAvaloirs = true
    }else {
      this.isMontDesAvaloirs = false
    }
  }



}

